import { createFileRoute } from "@tanstack/react-router";
import CommunityLayout from "lib/components/builders/communities/CommunityLayout";
import WorkbooksView from "lib/components/builders/communities/workbooks/WorkbooksView";
import { useAppRouterParams } from "lib/routeHelpers";
import withAuthentication from "../../../../../../components/withAuthentication";

function LocationWorkbooksPageReady() {
  const { builderId, locationId } = useAppRouterParams();

  if (!builderId || !locationId) {
    return null;
  }

  return <LocationWorkbooksPage builderId={builderId} locationId={locationId} />;
}

function LocationWorkbooksPage({ builderId, locationId }: { builderId: string; locationId: string }) {
  return (
    <CommunityLayout currentPage="workbooks">
      <WorkbooksView builderId={builderId} locationId={locationId} />
    </CommunityLayout>
  );
}

export const Route = createFileRoute("/builders/$builder_id/locations/$location_id/workbooks/")({
  component: withAuthentication(LocationWorkbooksPageReady, { features: ["locationWorkbooks"] }),
});
